exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".main-projects__carousel .main-projects-label__h3[data-v-1f37867b]{position:absolute;width:100%;height:100%;margin:0;text-align:center;line-height:200px;color:#475669;background-color:hsla(0,0%,100%,.5);z-index:1}.main-projects__carousel .el-carousel__item[data-v-1f37867b]:nth-child(2n){background-color:#99a9bf}.main-projects__carousel .el-carousel__item[data-v-1f37867b]:nth-child(odd){background-color:#d3dce6}.main-projects__carousel .main-projects-preview__iframe[data-v-1f37867b]{width:100%;height:100%;margin:0;padding:0;border:none;-webkit-filter:blur(3px);filter:blur(3px)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1f37867b","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/main/projects/projects.vue
// module id = 206
// module chunks = 0